import { BindingEngine } from "aurelia-binding";
import { EventAggregator } from "aurelia-event-aggregator";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { SignalClientService } from '@rightship-tech/common-ui/services/basic/signal-client.service';
import { SignalFunctions } from "../../../../services/basics/signal-functions";
import { ValidationsClientService } from "../../../../services/validations/validations-client.service";
import { ManageVesselService } from "../../../../services/vessels/manage-vessel.service";
import { BaseEntity } from "../base-entity";
import { IEntityTypeIdentifier } from "@rightship-tech/common-ui/models/basic.models";

export abstract class BaseRatingEntity<T> {

    public item: T;

    constructor(protected signalClientService: SignalClientService, protected manageVesselService: ManageVesselService)
    {}

    onAttached()
    {

    }

    onDetached()
    {
        
    }

    attached() {
        this.signalClientService.subscribe(SignalFunctions.systemRuleChanged, this.refreshRating);
        this.onAttached();
    }

    detached() {
        this.signalClientService.unsubscribe(SignalFunctions.systemRuleChanged, this.refreshRating);
        this.onDetached();
    }

    private refreshRating = async (param) => {
        if (this.item && Object.prototype.hasOwnProperty.call(this.item, "vesselId") && param && param.vesselIds && param.vesselIds.filter(x => x == this.item["vesselId"]).length >= 1) {
            try {
                const response = await this.manageVesselService.getRatingsModel(this.item["vesselId"]);
                
                if(Object.prototype.hasOwnProperty.call(this.item, "starRating"))
                    this.item["starRating"] = response.starRating;
                if(Object.prototype.hasOwnProperty.call(this.item, "rating"))
                    this.item["rating"] = response.rating;
                if(Object.prototype.hasOwnProperty.call(this.item, "systemRuleLastExecutedStatus"))
                    this.item["systemRuleLastExecutedStatus"] = response.systemRuleLastExecutedStatus;
                if(Object.prototype.hasOwnProperty.call(this.item, "ratingPlus"))
                    this.item["ratingPlus"] = response.ratingPlus;
                if(Object.prototype.hasOwnProperty.call(this.item, "isRatingVerified"))
                    this.item["isRatingVerified"] = response.isVerified;
                if(Object.prototype.hasOwnProperty.call(this.item, "safetyRatingType"))
                    this.item["safetyRatingType"] = response.safetyRatingType;
            } catch (e) {
                console.log("Failed to download doc fleet", e);
            }
        }
    }
}

export abstract class RatingBaseEntity<T extends IEntityTypeIdentifier> extends BaseEntity<T> {

    constructor(protected router: Router,
        protected bindingEngine: BindingEngine,
        protected i18N: I18N,
        protected notificationService: NotificationClientService,
        protected eventAggregator: EventAggregator,
        protected validationsClientService: ValidationsClientService,
        protected signalClientService: SignalClientService,
        protected manageVesselService: ManageVesselService)
    {
        super(router, bindingEngine, i18N, notificationService, eventAggregator, validationsClientService);
    }

    onAttached()
    {

    }

    onDetached()
    {
        
    }

    attached() {
        this.signalClientService.subscribe(SignalFunctions.systemRuleChanged, this.refreshRating);
        this.onAttached();
    }

    detached() {
        this.signalClientService.unsubscribe(SignalFunctions.systemRuleChanged, this.refreshRating);
        this.onDetached();
    }

    private refreshRating = async (param) => {
        if (this.item && Object.prototype.hasOwnProperty.call(this.item, "vesselId") && param && param.vesselIds && param.vesselIds.filter(x => x == this.item["vesselId"]).length >= 1) {
            try {
                const response = await this.manageVesselService.getRatingsModel(this.item["vesselId"]);
                
                if(Object.prototype.hasOwnProperty.call(this.item, "starRating"))
                    this.item["starRating"] = response.starRating;
                if(Object.prototype.hasOwnProperty.call(this.item, "rating"))
                    this.item["rating"] = response.rating;
                if(Object.prototype.hasOwnProperty.call(this.item, "systemRuleLastExecutedStatus"))
                    this.item["systemRuleLastExecutedStatus"] = response.systemRuleLastExecutedStatus;
                if(Object.prototype.hasOwnProperty.call(this.item, "ratingPlus"))
                    this.item["ratingPlus"] = response.ratingPlus;
                if(Object.prototype.hasOwnProperty.call(this.item, "isRatingVerified"))
                    this.item["isRatingVerified"] = response.isVerified;
                if(Object.prototype.hasOwnProperty.call(this.item, "safetyRatingType"))
                    this.item["safetyRatingType"] = response.safetyRatingType;
            } catch (e) {
                console.log("Failed to refresh rating", e);
            }
        }
    }
}